import { type ObjectValuesUnionType } from '../../../utils/typing';

export const BoomUserStatuses = Object.freeze({
  IN: 'IN', // Register in
  OFF: 'OFF', // Not registered
  EXCLUDED: 'EXCLUDED', // Excluded
});

export type BoomUserStatus = ObjectValuesUnionType<typeof BoomUserStatuses>;
